import React, { useState } from "react";
import { Button, Tooltip } from "@mui/material";
import { RefreshIcon, FillGapsIcon } from "assets";
import { USER_ROLES, useUserRole } from "recoils/user";
import { ExtrapolationModal } from "../extrapolationModal";
import { SendReminderButton } from "../sendReminder";
import { ExtrapolationActionType } from "../../types";
import { BulkActionsButtonsProps } from "./types";

export const BulkActionsButtons = ({
    selectedCollectorIds,
    fromDate,
    toDate,
    onRefreshAfterSave,
    totalSelectedRows,
    selectedRowsData,
}: BulkActionsButtonsProps) => {
    const [isExtrapolationModalOpen, setIsExtrapolationModalOpen] = useState(false);
    const [extrapolationActionType, setExtrapolationActionType] = useState<ExtrapolationActionType | null>(null);

    const openExtrapolationModal = (actionType: ExtrapolationActionType) => {
        setExtrapolationActionType(actionType);
        setIsExtrapolationModalOpen(true);
    };

    const closeExtrapolationModal = () => {
        setIsExtrapolationModalOpen(false);
        setExtrapolationActionType(null);
    };

    const onRefreshExtrapolationClick = () => {
        openExtrapolationModal("refreshExtrapolation");
    };

    const onFillGapsClick = () => {
        openExtrapolationModal("fillGaps");
    };

    const userRole = useUserRole();
    const canSendReminder = userRole.isRoleIn([
        USER_ROLES.MODULE_ADMIN,
        USER_ROLES.SUPER_ADMIN,
        USER_ROLES.DATA_VALIDATOR,
        USER_ROLES.DATA_REVIEWER,
    ]);

    const isFillGapsAction = extrapolationActionType === "fillGaps";

    return (
        <>
            {canSendReminder && <SendReminderButton
                totalSelectedRows={totalSelectedRows}
                collectorIds={selectedCollectorIds}
                fromDate={fromDate}
                toDate={toDate}
                selectedRowsData={selectedRowsData}
            />}
            <Tooltip arrow placement="top" title="Refresh existing extrapolated values using the latest usage data">
                <Button
                    startIcon={<RefreshIcon />}
                    variant="contained"
                    sx={{ borderRadius: "8px", width: 'fit-content' }}
                    disabled={selectedCollectorIds.length === 0}
                    onClick={onRefreshExtrapolationClick}
                >
                    Refresh Extrapolation
                </Button>
            </Tooltip>
            <Tooltip arrow placement="top" title="Bulk fill missing days with estimated usage data">
                <Button
                    startIcon={<FillGapsIcon />}
                    variant="contained"
                    sx={{ borderRadius: "8px", width: 'fit-content' }}
                    disabled={selectedCollectorIds.length === 0}
                    onClick={onFillGapsClick}
                >
                    Fill Gaps
                </Button>
            </Tooltip>
            {isExtrapolationModalOpen && <ExtrapolationModal
                isOpen={isExtrapolationModalOpen}
                onClose={closeExtrapolationModal}
                onSaveButtonClick={onRefreshAfterSave ?? (() => { })}
                selectedCollectorIds={selectedCollectorIds}
                isFillGapsAction={isFillGapsAction}
            />}
        </>
    );
};